module.exports = __webpack_public_path__ + "static/media/preview.42aa7fad.png";